export const ERROR_MESSAGES = {
  SERVER: 'Server error. Please call system administrator',
  LONG: 'Some error occurred, please report it to development team'
};
